const StatusBadge = ({
  statusStyle,
  statusText,
}: {
  statusStyle: string;
  statusText: string;
}) => {
  return (
    <div className="mb-0 mt-0">
      <h5 className="mb-0 mt-0">
        <span
          className={`badge bg-${statusStyle}-subtle text-${statusStyle}`}
          style={{
            width: '8rem',
            objectFit: 'cover',
            padding: '0.8rem 0.2rem',
            borderRadius: '0.25rem',
          }}
        >
          {statusText}
        </span>
      </h5>
    </div>
  );
};

export default StatusBadge;
